/**
 * 类型字典
 * */

// 文本
export const TEXTTYPES = ['dox', 'docx', 'xls', 'xlsx', 'pdf', 'DOX', 'DOCX', 'XLS', 'XLSX', 'PDF']

// 演示文稿
export const PAGETYPES = ['dox', 'docx', 'xls', 'xlsx', 'pdf', 'DOX', 'DOCX', 'XLS', 'XLSX', 'PDF']

// 音频
export const AUDIOTYPES = [
    'mp3',
    'wma',
    'rm',
    'wav',
    'midi',
    'ape',
    'flac',
    'MP3',
    'WMA',
    'RM',
    'WAV',
    'MIDI',
    'APE',
    'FLAC'
]

// 视频
export const VIDEOTYPES = [
    'asf',
    'avi',
    'flv',
    'm4v',
    'mov',
    'mp4',
    'rmvb',
    'wmv',
    'mkv',
    'mpeg',
    'rm',
    'mpg',
    'ASF',
    'AVI',
    'FLV',
    'M4V',
    'MOV',
    'MP4',
    'RMVB',
    'WMV',
    'MKV',
    'MPEG',
    'RM',
    'MPG'
]

// 图片
export const PICTYPES = ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'GIF', 'JPG', 'JPEG', 'PNG', 'BMP']
